
export const wordbank = s => s.wordbank;
export const currentCategory = s => s.currentCategory;
export const isEditMode = s => s.isEditMode;
export const isFilterMode = s => s.isFilterMode;
export const allWordbanks = s => s.allWordbanks;

export const isActiveId = s => s.isActiveId;

export const hasNewCategory = s => s.hasNewCategory;



// WEBPACK FOOTER //
// ./src/modules/Wordbank/_store/getter.js